import { Record } from "./record";

export class GenericRecord extends Record {};